import { View, Text } from 'react-native'
import React from 'react'

export default function Document() {
  return (
    <View>
      <Text>Document</Text>
    </View>
  )
}